// extracted by mini-css-extract-plugin
export var ignore = "_6y-1";
export var mapping = "_6y-0";
export var range = "_6y-4";
export var savings = "_6y-3";
export var settings = "_6y-2";